/* eslint-disable @typescript-eslint/no-explicit-any */
import {CreateFeature} from "../model/request/feature/CreateFeature.ts";
import {BaseService} from "./BaseService.ts";

export class FeatureService {
    static create = (others: any, data: CreateFeature) => {
        return BaseService.apiClient(others).post("/feature/create", data);
    };
    static update = (others: any, data: CreateFeature) => {
        return BaseService.apiClient(others).post("/feature/update", data);
    };
    static delete = (others: any, data: CreateFeature) => {
        return BaseService.apiClient(others).post("/feature/delete", data);
    };
}
